import { multipleBeacons } from 'app-webtech-core/beacon/multipleBeacons';
import { withFields } from 'app-webtech-core/beacon/withFields';
import { HEARTBEAT, SESSION_RESET } from '../actions/types';

import { bootstrapLoadedBeacon } from '../../application/beacons/bootstrapLoaded';
import { heartBeatBeacon } from './heartBeat';
import { msnHeartBeatBeacon } from './msnHeartBeat';
import { sessionResetBeacon } from './sessionReset';

export const playbackEventDefinitionsMap = {
  [HEARTBEAT]: multipleBeacons(withFields(heartBeatBeacon), msnHeartBeatBeacon),
  [SESSION_RESET]: multipleBeacons(
    withFields(sessionResetBeacon),
    withFields(bootstrapLoadedBeacon),
  ),
};
